import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { shouldUpdate } from 'recompose';
import TreatmentInstanceDialogContent from './TreatmentInstanceDialogContent/TreatmentInstanceDialogContent';
import Spinner from '../../common/Spinner/Spinner';
import globals from '../../../globals/communityGlobals';
import { cardTypes } from '../../../settings/constants';

import { Treatment, TreatmentDefaultProps } from '../../../propTypes/entities/treatment';
import treatmentInstancePropType from '../../../propTypes/entities/treatmentInstance';

const locale = globals.getArea('treatments');

export const treatmentInstanceDialogActions = {
  EDIT: 'EDIT',
  CANCEL: 'CANCEL',
  MOVE: 'MOVE',
};

const initialState = {
  action: treatmentInstanceDialogActions.EDIT,
  actionProps: {},
};

const cancelTreatmentMsg = locale.getMsg('cancelTreatment');

const contentWidthPadded = '752px';
const contentHeight = '510px';
const styles = {
  dialog: {
    maxWidth: contentWidthPadded,
    height: contentHeight,
    minHeight: contentHeight,
    maxHeight: contentHeight, // info: without this dialog jumps
  },
  content: { width: contentWidthPadded, maxWidth: '760px' },
  flatButton: { margin: '-57px 0px 0px 100px', color: 'red' },
};
class TreatmentInstanceDialog extends React.PureComponent {
  state = initialState;
  componentDidUpdate = prevProps => {
    const { id } = this.props;

    if (!this.checkVisibility(prevProps.dialogs[id])) {
      this.setState(initialState);
    }
  };

  onRequestClose = () => this.props.hide(this.props.id);

  checkVisibility = dialog => (dialog ? dialog.isVisible : false);

  changeDialogAction = (action, props = {}) => {
    this.setState({
      action: action || this.state.action,
      actionProps: {
        ...this.state.actionProps,
        ...props,
      },
    });
  };

  showCancellationForm = () => {
    this.changeDialogAction(treatmentInstanceDialogActions.CANCEL);
  };

  // todo: commonize this method somewhere
  isMaster = () => this.props.cardType === cardTypes.MASTER || this.props.cardType === cardTypes.REVIEW;

  render() {
    const {
      isFetching,
      treatment,
      treatmentInstanceId,
      dateAt,
      dialogs,
      id,
      treatmentInstances,
      cardType,
      canAllocateWork,
      canEditTreaments,
    } = this.props;
    const { action, actionProps } = this.state;
    const dialog = dialogs[id];

    const canIteract = canAllocateWork || canEditTreaments;

    const treatmentInstance = treatment
      ? treatmentInstances.find(i => i.treatmentInstanceId === treatmentInstanceId && i.treatmentId === treatment.id)
      : null;

    const isSpinning = isFetching || !treatment || !treatmentInstance;

    return (
      <div>
        <Dialog open={this.checkVisibility(dialog)} dividers={'paper'} onClose={this.onRequestClose} className="dialog">
          <DialogContent>
            {isSpinning ? (
              <Spinner />
            ) : (
              <TreatmentInstanceDialogContent
                dateAt={dateAt}
                canIteract={canIteract}
                action={action}
                actionProps={actionProps}
                changeDialogAction={this.changeDialogAction}
                treatment={treatment}
                treatmentInstanceId={treatmentInstanceId}
                treatmentInstance={treatmentInstance}
                isMaster={this.isMaster()}
                cardType={cardType}
                handleClose={this.onRequestClose}
              />
            )}
            <div className="cancel-treatment-button">
              {action === treatmentInstanceDialogActions.EDIT && this.isMaster() && (
                <FlatButton
                  style={styles.flatButton}
                  label={cancelTreatmentMsg}
                  onClick={this.showCancellationForm}
                  disabled={!canIteract}
                />
              )}
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

TreatmentInstanceDialog.defaultProps = {
  treatment: TreatmentDefaultProps,
  treatmentInstance: null,
  treatmentInstances: [],
};

TreatmentInstanceDialog.propTypes = {
  id: PropTypes.string.isRequired,
  dateAt: PropTypes.string.isRequired,
  treatmentInstanceId: PropTypes.number.isRequired,
  hide: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  cardType: PropTypes.string.isRequired,
  treatment: Treatment,
  dialogs: PropTypes.objectOf(
    PropTypes.shape({
      isVisible: PropTypes.bool,
    }),
  ).isRequired,
  treatmentInstances: PropTypes.arrayOf(treatmentInstancePropType),
  canEditTreaments: PropTypes.bool.isRequired,
  canAllocateWork: PropTypes.bool.isRequired,
};

const checkPropsChange = (props, nextProps) =>
  props.treatmentInstanceId !== nextProps.treatmentInstanceId ||
  Object.keys(props.dialogs).join(',') !== Object.keys(nextProps.dialogs).join(',') ||
  Object.values(props.dialogs)
    .map(v => v.isVisible)
    .join(',') !==
    Object.values(nextProps.dialogs)
      .map(v => v.isVisible)
      .join(',') ||
  props.isFetching !== nextProps.isFetching;

export default shouldUpdate(checkPropsChange)(TreatmentInstanceDialog);
